import { render, staticRenderFns } from "./oauth2-callback.vue?vue&type=template&id=77bcd134&"
import script from "./oauth2-callback.vue?vue&type=script&lang=js&"
export * from "./oauth2-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports